import { Col, Form, Input, Modal, Row } from "antd"
import { forwardRef, useContext, useImperativeHandle, useState } from "react"
import Text from "../Typography/Text"
import ControllerWarpper from "../ControllerWarpper"
import { useTranslation } from "react-i18next"
import { ModalCharterContext } from "."
import { thunks } from "@/lib/redux/thunks"
import { useDispatch } from "react-redux"
import { useAppDispatch } from "@/lib/redux/hooks"
import { useAirports } from "@/hooks/flight/useAirports"
import { useTETranslation } from "@/hooks/app/useTETranslation"

export type ModalConfirmPaymentRef = {
  close: () => void,
  open: () => void
}

type ModalConfirmPaymentType = {
  onDone: () => void
}

const ModalConfirmPayment = forwardRef<ModalConfirmPaymentRef, ModalConfirmPaymentType>(({ onDone }, ref) => {
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation()
  const { formVerify, form } = useContext(ModalCharterContext)
  const dispatch = useAppDispatch()
  const airports = useAirports()
  const { getFormatCurrency } = useTETranslation()

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  useImperativeHandle(ref, () => {
    return {
      close: handleClose,
      open: handleOpen
    }
  }, [])

  return (
    <Modal
      title={t("flight.charter_confirm_payment_title")}
      open={open}
      onCancel={handleClose}
      okText={t("common.confirm_paid_payment")}
      cancelText={t("common.cancel")}
      onOk={formVerify?.handleSubmit(({ verifyCode: confirmedVerifyCode }) => {
        if (!confirmedVerifyCode) {
          formVerify.setError("verifyCode", { message: t("flight.charter_confirm_payment_code_required") })
          return;
        }

        form?.handleSubmit((values) => {
          if (confirmedVerifyCode !== values.verifyCode) {
            formVerify.setError("verifyCode", { message: t("flight.charter_confirm_payment_code_rule") })
            return;
          };
          const [flightNumber, route, date, time] = values.flight.split('_')
          const startPoint = airports[route.slice(0, 3)]
          const endPoint = airports[route.slice(3)]

          const genderTitle: any = {
            Mr: "Ông",
            Mrs: "Bà",
            boy: "Bé trai",
            girl: "Bé gái"
          }

          dispatch(thunks.force_send_mail({
            body: {
              TYPE: 'JSON',
              to: values?.contact?.email,
              bcc: "booking.th@hophilong.vn",
              subject: `VE MAY BAY TET2026 - ${values.contact.fullname}`,
              body: `<p>K&iacute;nh gửi Qu&yacute; kh&aacute;ch h&agrave;ng ${values.contact.fullname}</p><p><span style="font-weight:bold;">TravelEasy</span> xin x&aacute;c nhận dịch vụ đặt chỗ v&eacute; m&aacute;y bay của Qu&yacute; kh&aacute;ch đ&atilde; được thực hiện th&agrave;nh c&ocirc;ng.</p><p>Th&ocirc;ng tin chi tiết như sau:</p><p style="font-weight: bold;">Th&ocirc;ng tin li&ecirc;n hệ</p><div style="margin-left: 30px;"><p><span style="width:150px;display:inline-block;">Người li&ecirc;n hệ</span>: ${values.contact.fullname}</p><p><span style="width:150px;display:inline-block;">Số điện thoại</span>: ${values.contact.phone}</p><p><span style="width:150px;display:inline-block;">M&atilde; xác nhận đơn hàng</span>: ${values.verifyCode}</p></div><p style="font-weight: bold;">Th&ocirc;ng tin v&eacute;</p><div style="margin-left: 30px;"><p><span style="width:150px;display:inline-block;">M&atilde; đặt chỗ</span>: (th&ocirc;ng b&aacute;o sau)</p><p><span style="width:150px;display:inline-block;">H&atilde;ng</span>: VietnamAirlines</p><div style="display: flex; flex-wrap: nowrap;"><div style="margin-right: 15px;"><span style="width:150px;display:inline-block;">T&ecirc;n h&agrave;nh kh&aacute;ch</span>:</div><div>${values.passengers.map((pass: any) => `<p style="margin-top: 0px;">${genderTitle[pass.gender]}. ${pass.fullname}</p>`).join('')}</div></div><p><span style="width:150px;display:inline-block;">H&agrave;nh tr&igrave;nh</span>: ${startPoint.cityVi} (${startPoint.code}) - ${endPoint.cityVi} (${endPoint.code}), ${date} - ${time}, ${flightNumber}</p><p><span style="width:150px;display:inline-block;">Gi&aacute; v&eacute;</span>: ${getFormatCurrency(900000)}/ kh&aacute;ch * ${values.passengers.length} kh&aacute;ch</p><span style="width:150px;display:inline-block;">Tổng thanh to&aacute;n</span>: <span style="font-weight:bold;">${getFormatCurrency(900000 * values.passengers.length)}</span></div><p style="font-weight: bold;">Điều kiện v&eacute;</p><div style="margin-left: 30px;"><p>H&agrave;nh l&yacute; X&aacute;ch tay 10kg, K&yacute; gửi 01 kiện * 23kg</p><p>Được đổi t&ecirc;n trước 07 ng&agrave;y so với ng&agrave;y bay</p><p>M&atilde; dặt chỗ c&oacute; trước 03 ng&agrave;y so với ng&agrave;y bay</p><p>V&eacute; kh&ocirc;ng ho&agrave;n / hủy / đổi h&agrave;nh tr&igrave;nh</p><p>Delay theo giờ bay H&atilde;ng (nếu c&oacute;)</p></div><p style="font-weight: bold;">Hotline: <span style="color:red">1900 292959</span></p></div><p>Tr&acirc;n trọng cảm ơn Qu&yacute; Kh&aacute;ch h&agrave;ng đ&atilde; tin tưởng v&agrave; sử dụng dịch vụ.</p><p>Ch&uacute;c Qu&yacute; kh&aacute;ch c&oacute; chuyến đi vui vẻ.</p>`,
              type: "TE"
            }
          })).then(() => {
            onDone()
            handleClose()
          }).catch(() => {

          });
        })()

      })}
    >
      <Row>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Form
                layout='vertical'
              >
                <ControllerWarpper
                  name={"verifyCode"}
                  control={formVerify?.control}
                  label={t("flight.charter_confirm_payment_code_label")}
                  required
                  render={({ field }) => {
                    return (
                      <Input {...field} />
                    )
                  }}
                />
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  )
})

export default ModalConfirmPayment